import { render, staticRenderFns } from "./Emprendimiento.vue?vue&type=template&id=04d3c110&"
import script from "./Emprendimiento.vue?vue&type=script&lang=js&"
export * from "./Emprendimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports